var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section", { staticClass: "box mb-0" }, [
        _c("h1", { staticClass: "title is-5" }, [
          _vm._v("Eventos de la serie"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.serieDocumental.eventos.length == 0
          ? _c("p", { staticClass: "mt-5 is-italic is-mono" }, [
              _vm._v(
                "\r\n          - No hay eventos en la serie -\r\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._l(_vm.serieDocumental.eventos, function (evento, index) {
        return _c(
          "b-collapse",
          {
            key: index,
            staticClass: "card is-radiusless my-1 is-shadowless",
            attrs: { animation: "slide", open: _vm.isOpen == index },
            on: {
              open: function ($event) {
                _vm.isOpen = index
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "trigger",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "card-header is-radiusless",
                          attrs: { role: "button" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-header-title is-flex-direction-column is-align-items-start",
                            },
                            [
                              _c("p", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "Evento:  " + _vm._s(evento.nombre) + " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "is-4 ml-5 has-text-primary is-400",
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-bolt" }),
                                    _vm._v(
                                      " " + _vm._s(evento.acciones.length)
                                    ),
                                  ]
                                ),
                                evento.areas_habilitadas
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "is-4 ml-5 has-text-primary is-400",
                                      },
                                      [
                                        _c("i", { staticClass: "fas fa-lock" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              evento.areas_habilitadas.length
                                            ) +
                                            " Areas"
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tags is-400" },
                                [
                                  _vm._l(
                                    evento.estados_iniciales,
                                    function (e) {
                                      return _c(
                                        "span",
                                        {
                                          key: e,
                                          staticClass: "tag",
                                          class:
                                            e !=
                                            _vm.serieDocumental.estado_inicial
                                              ? "is-light"
                                              : "is-link",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.serieDocumental.estados[e]
                                            )
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tag is-white" }, [
                                    _c("i", {
                                      staticClass: "fas fa-arrow-right",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm.serieDocumental.estados[
                                    evento.estado_final
                                  ]
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "tag",
                                          class:
                                            evento.estado_final !=
                                            _vm.serieDocumental.estado_inicial
                                              ? "is-light"
                                              : "is-link",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.serieDocumental.estados[
                                                evento.estado_final
                                              ]
                                            )
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "tag is-light" },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-asterisk",
                                          }),
                                        ]
                                      ),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { staticClass: "card-header-icon" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: props.open ? "angle-up" : "angle-down",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          [
            _vm._v(" "),
            _c("div", { staticClass: "card-content" }, [
              _c("h1", { staticClass: "subtitle is-4" }, [
                _vm._v("\r\n                Evento\r\n              "),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "title is-3" }, [
                _vm._v(
                  "\r\n                " +
                    _vm._s(evento.nombre) +
                    "\r\n              "
                ),
              ]),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "breadcrumb has-bullet-separator",
                  attrs: { "aria-label": "breadcrumbs" },
                },
                [
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openModalEditarEvento(evento)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-edit" }),
                          _vm._v(" Editar"),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "has-text-danger",
                          on: {
                            click: function ($event) {
                              return _vm.openModalEliminarEvento(evento)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-times-circle" }),
                          _vm._v(" Eliminar"),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-6" }, [
                  _c("h1", { staticClass: "subtitle is-5" }, [
                    _vm._v("Estados iniciales"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tags" },
                    _vm._l(evento.estados_iniciales, function (e) {
                      return _c(
                        "span",
                        {
                          key: e,
                          staticClass: "tag is-medium",
                          class:
                            e != _vm.serieDocumental.estado_inicial
                              ? "is-light"
                              : "is-link",
                        },
                        [_vm._v(_vm._s(_vm.serieDocumental.estados[e]))]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-6" }, [
                  _c("h1", { staticClass: "subtitle is-5" }, [
                    _vm._v("Estados final"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tags" }, [
                    _vm.serieDocumental.estados[evento.estado_final]
                      ? _c("span", { staticClass: "tag is-primary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.serieDocumental.estados[evento.estado_final]
                            )
                          ),
                        ])
                      : _c("span", [
                          _c("i", [
                            _c("i", { staticClass: "fas fa-asterisk" }),
                            _vm._v(
                              " Mantiene el estado\r\n                      "
                            ),
                          ]),
                        ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h1", { staticClass: "subtitle is-5" }, [
                _vm._v("Areas habilitadas para ejecutar acciones"),
              ]),
              _vm._v(" "),
              evento.areas_habilitadas
                ? _c(
                    "div",
                    { staticClass: "tags" },
                    _vm._l(evento.areas_habilitadas, function (a) {
                      return _c(
                        "span",
                        { key: a, staticClass: "tag is-dark" },
                        [_vm._v(_vm._s(_vm.getArea(a) || "???"))]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "content" }, [
                    _c("p", { staticClass: "is-italic is-mono" }, [
                      _vm._v("Todas las areas pueden ejecutar las acciones"),
                    ]),
                  ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h1", { staticClass: "title is-5" }, [_vm._v("Acciones")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _vm._v(
                    "Puede editar la descripción de las acciones haciendo clic en "
                  ),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _c("i", { staticClass: "fas fa-edit" }),
                  ]),
                  _vm._v(", o eliminarlas haciendo clic sobre el ícono "),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _c("i", { staticClass: "fas fa-times-circle" }),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("b", [_vm._v("NOTA:")]),
                  _vm._v(
                    " No puede eliminar acciones que pertenezcan a un evento que se encuentre en ejecución en al menos una unidad."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary is-outlined",
                    on: {
                      click: function ($event) {
                        return _vm.openModalNuevaAccion(evento)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus" }),
                    _vm._v(" Agregar acción"),
                  ]
                ),
              ]),
              _vm._v(" "),
              evento.acciones.length === 0
                ? _c("div", { staticClass: "content" }, [
                    _c("p", { staticClass: "is-italic is-mono" }, [
                      _vm._v(
                        "No se requieren acciones para ejecutar el evento"
                      ),
                    ]),
                  ])
                : _c(
                    "div",
                    _vm._l(evento.acciones, function (a, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "box is-flex is-flex-direction-row",
                        },
                        [
                          _c("div", { staticClass: "mr-4" }, [
                            _c("i", {
                              staticClass: "fas fa-bolt fa-2x has-text-primary",
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-flex-grow-1" }, [
                            _c("h1", { staticClass: "subtitle is-6" }, [
                              _vm._v("Acción #" + _vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c("h1", { staticClass: "title is-5 mb-3" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getNombreAccion(a.documento_operacion_id)
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "is-italic" }, [
                              _vm._v(_vm._s(a.descripcion)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-4" }, [
                            _c("p", { staticClass: "mb-3" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "has-text-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openModalEditarAccion(
                                        evento,
                                        a
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fas fa-edit fa-lg" })]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "my-3",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDialogDeleteAccion(evento, a)
                                  },
                                },
                              },
                              [
                                _c("a", { staticClass: "has-text-primary" }, [
                                  _c("i", {
                                    staticClass: "fas fa-times-circle fa-lg",
                                  }),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mb-5" },
        [
          _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Nuevo evento")]),
          _vm._v(" "),
          _c("crear-evento", { on: { update: _vm.crearEvento } }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Para ver la información extendida de cada evento, haga clic en el icono "
        ),
        _c("i", { staticClass: "fas fa-angle-down fa-fw has-text-primary" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }